import API from "../../../utils/helpers/API.helpers";

const TermService = {
  async getTermList() {
    return await API.get({ endpoint: "/term/", isWithoutAuth: true });
  },
  async createTerm(termDetails) {
    let data = {
      semester: termDetails.semester,
      periode: termDetails.periode,
    };

    let response = await API.post({ endpoint: "/term/", data: data });
    return response;
  },
  async updateTerm(termDetails) {
    return await API.put({
      endpoint: `/term/${termDetails.id_term}/`,
      data: termDetails,
    });
  },
  async deleteTerm(termId) {
    return await API.delete({ endpoint: `/term/${termId}/` });
  },
};

export default TermService;
